<!-- Navigation menu (toolbar) -->
<app-nav></app-nav>
<iframe #frame [src]="subUrl | safe"></iframe>
